import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      original &&
      !original._retry &&
      !String(original.url || "").includes("/auth/")
    ) {
      original._retry = true;
      try {
        await axios.post(`${BASE}/api/auth/refresh`, {}, { withCredentials: true });
        return api(original);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(e) {
  const detail = e?.response?.data?.detail ?? e?.message;
  if (detail == null) return "Bir şeyler ters gitti. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
      .filter(Boolean)
      .join(" ");
  }
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function waLink(phone, title) {
  const p = (phone || "").replace(/\D/g, "");
  const text = `Merhaba, alsat67.com'daki "${title}" ilanınız hakkında bilgi almak istiyorum.`;
  return `https://wa.me/${p}?text=${encodeURIComponent(text)}`;
}

export function imgSrc(url, w = 800) {
  if (!url || url.startsWith("data:")) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}w=${w}&auto=format&fit=crop`;
}

export const CATEGORIES = [
  { id: "elektronik", name: "Elektronik" },
  { id: "telefon", name: "Telefon & Aksesuar" },
  { id: "ev-yasam", name: "Ev & Yaşam" },
  { id: "mobilya", name: "Mobilya & Dekor" },
  { id: "giyim", name: "Giyim & Moda" },
  { id: "vasita", name: "Vasıta & Oto" },
  { id: "diger", name: "Diğer" },
];

export const DISTRICTS = ["Merkez", "Ereğli", "Çaycuma", "Devrek", "Kozlu", "Kilimli", "Alaplı", "Gökçebey"];

export const STATUS_META = {
  pending: { label: "Onay Bekliyor", cls: "bg-amber2/20 text-amber-700 border-amber2/40" },
  approved: { label: "Yayında", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  revision: { label: "Revizyon İstenen", cls: "bg-orange-100 text-orange-800 border-orange-300" },
  rejected: { label: "Reddedildi", cls: "bg-red-100 text-red-700 border-red-300" },
};

export function formatPrice(v) {
  return new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 }).format(v) + " ₺";
}

export function formatDate(s) {
  if (!s) return "";
  const d = new Date(s);
  return d.toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric" });
}
